import { createAction } from '@reduxjs/toolkit';

export const allInPricingToggleInteraction = createAction(
	'chooseYourRoom/allInPricingToggleInteraction'
);

export const flexDateSelected = createAction('chooseYourRoom/flexDateSelected');
